<!-- 系统编码配置 -->
<template>
    <div class='container'>
        <el-row :gutter="20">
            <el-col :span="8">
                <p class="content-title" style="margin-bottom:10px;">配置分类</p>
                <lb-table
                    :column="sysTypeData.column"
                    :data="sysTypeData.data"
                    stripe
                    @current-change="handleCurrentChange">
                </lb-table>
            </el-col>
            <el-col :span="16">
                <p class="content-title handleForm" style="margin-bottom:10px;">
                    <span>取值分类</span>
                    <el-button class="title-btn" type="primary" style="margin-right:15px;" size="small" icon="el-icon-plus" @click="handleEventAdd">新增</el-button>
                </p>
                <lb-table
                    :column="tableData.column"
                    :data="tableData.data"
                    :height="maxHeight"
                    stripe>
                </lb-table>
            </el-col>
        </el-row>

        <!-- 新增+编辑弹框 -->
        <el-dialog title="编辑" width="40%" :visible.sync="dialogFormVisible">
            <el-form :model="addForm" :rules="addFormRule" label-width="120px" ref="addForm">
                <el-form-item label="配置编码" prop="code" >
                    <el-input v-model="addForm.code" autocomplete="off" :disabled="isdisabled"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item label="配置值" prop="value">
                    <el-input v-model="addForm.value" autocomplete="off"  :disabled="isdisabled"></el-input>
                </el-form-item>
                <el-form-item label="是否可变" prop="fixed">
                    <el-select v-model="addForm.fixed" placeholder="请选择活动区域"  :disabled="isdisabled">
                        <el-option label="是" :value="0"></el-option>
                        <el-option label="否" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Service from '@/api/Service'
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth, $Alert } from '@/utils/utils'
export default {
    name:  'systemdic',
    data() {
        return {
			isdisabled:false,
            sysTypeData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'type',
                        label: '配置类型',
                    },
                    {
                        prop: 'name',
                        label: '配置名称',
                    },
                ],
                data: []
            },
            tableData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'code',
                        label: '编码',
                    },
                    {
                        prop: 'name',
                        label: '名称',
                    },
                    {
                        prop: 'value',
                        label: '值',
                    },
                    {
                        prop: 'fixed',
                        label: '可变',
                        render: (h, scope) => {
                            return (
                                <el-tag type={scope.row.isfixed === 0 ? 'danger' : 'success'} effect="dark" size="medium" >{ scope.row.isfixed === 0 ? '不可变' : '可变' }</el-tag>
                            )
                        }
                    },
                    {
                        label: '操作',
                        render: (h, scope) => {
                        return (
                            <div>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                onClick={ () => { this.handleEdit(scope.$index, scope.row) } }>编辑</el-button>
                            </div>
                        )
                        }
                    }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,

            type_code: '',
            dialogFormVisible: false,
            addForm: {
                code: '',
                name: '',
                value: '',
                fixed: 0,
            },
            addFormRule: {
                code: [
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
            }
        };
    },

    components: { LbTable },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    created() {
        this.getSysType()
    },

    computed: {},

    methods: {
        async getSysType() {
            let res = await Service.getTypeSystemDic()
            if(res) {
                this.sysTypeData.data = res;
                this.getSysValue({type_code: res[0].type})
            }
        },
        async getSysValue(type_code) {
            this.type_code = type_code.type_code
            let res = await Service.getTypeCodeSystemDic(type_code)
            if(res){
                this.tableData.data = res
            }
        },
        handleEdit (index, row) {
			this.isdisabled = true
            this.isEdit = true
            this.dialogFormVisible = true;
            this.addForm = Object.assign({}, row)
        },
        handleCurrentChange (val) {
            this.getSysValue({type_code: val.type})
        },
        handleEventAdd() {
			this.isdisabled = false
            this.isEdit = false
            this.dialogFormVisible = true;
            this.addForm = {
                code: '',
                name: '',
                value: '',
                fixed: 0,
            }
        },
        handleSave() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res
                    if(this.isEdit) {
                        let { code, name, value } = this.addForm
                        res = await Service.editSysdict({code, name, value})
                    }else{
                        this.addForm.type_code = this.type_code
                        res = await Service.addSysdict(this.addForm)
                    }
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.dialogFormVisible = false;
                        this.getSysValue({type_code: this.type_code})
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}

</script>
<style lang='less' scoped>

</style>